import snsAxiosClient from '../common/http/http-sns';

function editQuantity(environmentVariables, user, editQuantityInfo) {
  const payload = { ...editQuantityInfo };
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_PATCH_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };

  return snsAxiosClient(options).patch(`${environmentVariables.SNS_EDIT_QUANTITY}${user.UUID}/editQuantity`, payload);
}

export default editQuantity;
